import classNames from './EditClass.module.scss';
import { useTranslation } from 'react-i18next';
import { useDrawer } from '@/context/DrawerContext';

import TeacherOnboarding from '../TeacherOnboarding/TeacherOnboarding';
import SectionSeperator from '../SectionSeperator/SectionSeperator';

const EditClass = () => {
  const { t } = useTranslation();
  const drawer = useDrawer();

  return (
    <div className={classNames.editClassDrawer} aria-label={t('edit').toString()}>
      <div className={classNames.top}>
        <h1>{t('editClass')}</h1>
        <h2>{t('invitationLinkWontChange')}</h2>
      </div>
      <SectionSeperator className={classNames.seperator} />
      <div className={classNames.body}>
        <TeacherOnboarding
          className={classNames.teacherOnboarding}
          showTop={false}
          showCopyBtn={false}
          hasMultipleControls
          isDrawer
          emitCancel={drawer.closeEditClass}
        />
      </div>
    </div>
  );
};

export default EditClass;
